import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import AddressIcon from 'assets/LeadInfo/address.svg';
import BusinessIcon from 'assets/LeadInfo/business.svg';
import DetailIcon from 'assets/LeadInfo/detail.svg';
import NumberIcon from 'assets/LeadInfo/number.svg';
import SourceIcon from 'assets/LeadInfo/source.svg';
import UsersIcon from 'assets/LeadInfo/users.svg';
import { getSingleTicket } from 'features/projectManagement/ProjectManagementActions';
import { selectSingleTicket } from 'features/projectManagement/ProjectManagementSlice';

import {
  ContactContent,
  ContactFildes,
  ContactFildesB,
  ContactInputBox,
  ContactTitle,
  InputContent,
  InputIcon,
  InputLabel,
  TitleIcon,
} from './DetailInfo.styles';

const DetailInfo = ({ leadData, assignedList }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const singleTicket = useSelector(selectSingleTicket);

  useEffect(() => {
    if (leadData?.ticketUuid) {
      dispatch(getSingleTicket(leadData.ticketUuid));
    }
  }, [leadData?.ticketUuid]);

  const assignedToText =
    leadData?.assignee?.name ||
    assignedList?.find((u) => u.uuid === leadData?.assigneeUuid)?.name;

  const addedByText = leadData?.createdBy
    ? `${leadData.createdBy.name}/${leadData.createdBy.userType}`
    : 'N/A';

  return (
    <ContactContent>
      <ContactTitle>
        <TitleIcon src={DetailIcon} />
        Lead Details
      </ContactTitle>
      {leadData?.businessType === 'B2B' &&
        (leadData?.webAddress || leadData?.numberOfEmployees) && (
          <ContactFildes>
            {leadData?.webAddress && (
              <ContactInputBox>
                <InputLabel>
                  <InputIcon src={AddressIcon} />
                  Web Address
                </InputLabel>
                <InputContent>{leadData.webAddress}</InputContent>
              </ContactInputBox>
            )}
            {leadData?.numberOfEmployees && (
              <ContactInputBox>
                <InputLabel>
                  <InputIcon className="width-icon" src={NumberIcon} />
                  Number of Employees
                </InputLabel>
                <InputContent>{leadData.numberOfEmployees}</InputContent>
              </ContactInputBox>
            )}
          </ContactFildes>
        )}
      {leadData?.description && (
        <ContactFildes>
          <ContactInputBox>
            <InputLabel>Description</InputLabel>
            <InputContent>{leadData.description}</InputContent>
          </ContactInputBox>
        </ContactFildes>
      )}

      <ContactFildesB>
        <ContactFildes>
          {leadData?.businessType && (
            <ContactInputBox>
              <InputLabel>
                <InputIcon src={BusinessIcon} />
                Business model
              </InputLabel>
              <InputContent>{leadData.businessType}</InputContent>
            </ContactInputBox>
          )}
          <ContactInputBox>
            <InputLabel>
              <InputIcon className="width-icon" src={UsersIcon} />
              Assigned to
            </InputLabel>
            <InputContent>{assignedToText}</InputContent>
          </ContactInputBox>
        </ContactFildes>
        <ContactFildes>
          {leadData?.leadSource?.name && (
            <ContactInputBox>
              <InputLabel>
                <InputIcon className="source-icon" src={SourceIcon} />
                Source
              </InputLabel>
              <InputContent>{leadData.leadSource.name}</InputContent>
            </ContactInputBox>
          )}
          <ContactInputBox>
            <InputLabel>
              <InputIcon className="width-icon" src={UsersIcon} />
              Added by
            </InputLabel>
            <InputContent>{addedByText}</InputContent>
          </ContactInputBox>
        </ContactFildes>
        <ContactFildes>
          {leadData.ticketUuid && (
            <ContactInputBox>
              <InputLabel>Attached Ticket</InputLabel>
              <InputContent
                style={{ cursor: 'pointer', color: '#1890ff' }}
                onClick={() => navigate(`/project-management/ticket/${leadData.ticketUuid}`)}
              >
                {singleTicket?.title}
              </InputContent>
            </ContactInputBox>
          )}
        </ContactFildes>
        <ContactFildes>
          {leadData?.vivaProcess && (
            <ContactInputBox>
              <InputLabel>
                <InputIcon className="source-icon" src={SourceIcon} />
                Viva ID
              </InputLabel>
              <InputContent>{leadData.vivaProcess}</InputContent>
            </ContactInputBox>
          )}
        </ContactFildes>
      </ContactFildesB>
    </ContactContent>
  );
};

export default DetailInfo;
